/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useEffect} from 'react';
import {useRecoilValue, useRecoilState} from 'recoil';
import {
  currentSceneIDState,
  currentScreenState,
  sceneHistoryQueueState,
} from '../recoil/atoms';

import Loader from '../elements/Loader/Loader';
import GameIntro from './GameIntro';
import GameDetails from './GameDetails';
import {
  INTRO_SCREEN,
  PLAYLIST_SCREEN,
} from '../recoil/state';
import Scene from './Scene';
import {
  currentGameInfoQuery,
} from '../recoil/selectors';

function Game() {
  const currentScreen = useRecoilValue(currentScreenState);
  const [currentSceneID, setCurrentSceneID] = useRecoilState(currentSceneIDState);
  const sceneHistoryQueue = useRecoilValue(sceneHistoryQueueState);
  const currentGame = useRecoilValue(currentGameInfoQuery);

  // Add external events
  useEffect(() => {
    window.addEventListener('startgame', (e) => {
      setCurrentSceneID(currentGame.tree.id)
    });
    window.addEventListener('skiptoscene', (e) => {
      e.detail?.sceneId && setCurrentSceneID(e.detail.sceneId);
    });
  }, []);

  useEffect(() => {
    console.log("currentSceneID: ", currentSceneID);
    console.log("history Stack:", sceneHistoryQueue);
  }, [currentSceneID]);

  return (

        <>
          {!currentSceneID && currentScreen === INTRO_SCREEN &&
          <React.Suspense fallback={<Loader/>}>
            <GameIntro/>
          </React.Suspense>
          }

          {!currentSceneID && currentScreen === PLAYLIST_SCREEN &&
          <React.Suspense fallback={<Loader/>}>
            <GameDetails/>
          </React.Suspense>
          }

          {currentSceneID &&
          <React.Suspense fallback={<Loader/>}>
            <Scene/>
          </React.Suspense>
          }
        </>
  )
}

export default Game;
